import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ServiceRequest } from 'src/models';
import { api } from 'src/services';

type useCreateServiceRequestFromDocumentsPayload = {
  patientDocumentIds: string[];
};

export type CreateServiceRequestFromDocumentsResponse = ServiceRequest;

export const useCreateServiceRequestFromDocuments = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['createServiceRequestFromDocuments'],
    mutationFn: (payload: useCreateServiceRequestFromDocumentsPayload) => {
      return api
        .post('/v3/service_request/from_documents', {
          patient_document_ids: payload.patientDocumentIds,
        })
        .then(({ data }) => data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['serviceRequestList'] });
    },
  });
};
